import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import clvprediction from "../../Assets/Projects/clvprediction.png";
import sales from "../../Assets/Projects/evsales.png";
import echovid from "../../Assets/Projects/echovid.png";
import snakerl from "../../Assets/Projects/snakerl.png";
import covertune from "../../Assets/Projects/covertune.png";
import broker from "../../Assets/Projects/broker.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={echovid}
              title="EchoVid: Echoing Ideas Into Videos Using Generative AI"
              description={`EchoVid is an AI-powered generative tool that transforms audio into rich visual stories. 
                It uses Whisper for speech-to-text, Flan-T5 for text interpretation, and Stable Diffusion for image generation. 
                From voice input, it creates dynamic video content — ideal for album visuals, storytelling, or branding. 
                EchoVid bridges creativity and AI, turning spoken words into stunning visuals.`}
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={covertune}
              title="CoverTune AI: AI Album Cover Audio-To-Image Generator"
              description={`CoverTune AI is a creative generator that turns music into unique album art. 
                It uses OpenAI's Whisper to understand lyrics and Stable Diffusion to visualize the sound in artistic form. 
                This tool helps artists instantly create visually resonant cover designs from their audio tracks. 
                It's a fusion of audio analysis and generative image modeling.`}
              ghLink="https://github.com/snehapadgaonkar/CoverTune-AI.git"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={sales}
              title="Tesla's EV Charging Network Optimization"
              description={`This project analyzes Tesla's EV sales and charging station usage to optimize network planning. 
                By applying geospatial clustering and sales trends, it identifies ideal station locations. 
                The analysis improves accessibility and utilization of Tesla's infrastructure. 
                A strong example of data-driven decision-making in the EV space.`}
              ghLink="https://github.com/snehapadgaonkar/Tesla-EV-Sales-Analysis.git"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={snakerl}
              title="SnakeRL: RL-Powered Snake Game Simulation"
              description={`SnakeRL reimagines the classic Snake game with Reinforcement Learning. 
                It implements and compares Q-Learning and SARSA algorithms over hundreds of episodes. 
                The agent learns through reward-based feedback to improve gameplay over time which is trained over 500 episodes. 
                It's a hands-on demo of RL applied to a fun, nostalgic environment.`}
              ghLink="https://github.com/snehapadgaonkar/SnakeRL.git"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={broker}
              title="Broker-Based Multi-Cloud Task Scheduling for Latency Optimization"
              description={`This CloudSim simulation models a broker-based multi-cloud task scheduler. 
                It optimizes latency by smartly assigning tasks across cloud resources. 
                The project mimics real-world cloud environments and enhances resource utilization. 
                It showcases knowledge in distributed systems and performance modeling.`}
              ghLink="https://github.com/snehapadgaonkar/Latency-broker-cloudsim.git"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={clvprediction}
              title="Customer Lifetime Value Prediction"
              description={`This machine learning model predicts customer lifetime value based on purchasing behavior. 
                It classifies users into high or low value using models like Logistic Regression, Random Forest, and KNN. 
                Evaluation metrics include Accuracy, F1 Score, Precision, and AUC-ROC. 
                Useful for targeting marketing strategies and improving customer retention.`}
              ghLink="https://github.com/snehapadgaonkar/CLV-Prediction.git"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
